// src/components/common/ParticipantsListPage.tsx
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { XIcon, Mic, MicOff, Video, VideoOff } from "lucide-react";
import { Button } from "../ui/button"; 

interface Participant {
  id: string;
  name: string;
  avatar: string;
  isMuted: boolean;
  isVideoOff: boolean;
  email?: string; 
}

interface ParticipantsListPageProps {
  participants: Participant[];
  localUserId: string;
  onClose: () => void;
}

export function ParticipantsListPage({ participants, localUserId, onClose }: ParticipantsListPageProps) {
  return (
    <div className="flex flex-col bg-white rounded-xl overflow">
      <div className="flex items-center justify-between p-4 border-b">
        <h2 className="text-lg font-semibold">Participants ({participants.length})</h2>
        <Button variant="ghost" size="icon" onClick={onClose} className="rounded-full bg-blue-200">
          <XIcon className="h-5 w-5" />
          <span className="sr-only">Close participants list</span>
        </Button>
      </div>

      <div className="flex-grow overflow-y-auto p-4 custom-scrollbar">
        <div className="grid gap-4">
          {participants.map((p) => (
            <div key={p.id} className="flex items-center gap-4 bg-gray-100 p-3 rounded-lg">
              <Avatar className="h-10 w-10">
                <AvatarImage src={p.avatar} alt={p.name} />
                <AvatarFallback>{p.name.charAt(0)}</AvatarFallback>
              </Avatar>
              <div className="flex-grow">
                <p className="font-medium text-sm">
                  {p.name} {p.id === localUserId && "(You)"}
                </p>
                {p.email && <p className="text-muted-foreground text-xs">{p.email}</p>}
              </div>
              <div className="flex items-center space-x-2">
                {p.isMuted ? (
                  <MicOff className="h-4 w-4 text-red-500" />
                ) : (
                  <Mic className="h-4 w-4 text-green-500" />
                )}
                {p.isVideoOff ? (
                  <VideoOff className="h-4 w-4 text-red-500" />
                ) : (
                  <Video className="h-4 w-4 text-green-500" />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}